module.exports = __webpack_public_path__ + "static/media/Siplin.8e65e4ca.svg";